export default __webpack_public_path__ + "static/hub-tablet-9c5ee94a154212cc1c7f0db9f785db3f.jpg";